import styled from "styled-components";
import { ModalBody, ModalFooter } from "reactstrap";

export const TwoButtonModalFooter = styled(ModalFooter)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: var(--gap-m);
`;

export const FlexibleButtonModalFooter = styled(ModalFooter)`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, max-content));
    column-gap: var(--gap-m);
`;

export const PathwayModalBody = styled(ModalBody)`
    display: grid;
    column-gap: var(--gap-l);
    row-gap: var(--gap-l);
`;
